import Nothing from '@components/nothing';
import { useParrotPoolPriceOhlc } from '@hooks/use-parrot-pool-price-ohlc';
import { FC, useState } from 'react';
import { ParrotCoinStruct } from 'src/types';
import SwapChartLoading from './chart-loading';
import styles from './chart.module.scss';

const tabs = [
  {
    label: '1D',
    value: '1d',
  },
  {
    label: '1W',
    value: '1w',
  },
  {
    label: '1M',
    value: '1m',
  },
  {
    label: '1Y',
    value: '1y',
  },
  {
    label: 'All',
    value: 'all',
  },
];

interface OwnProps {
  coinB: ParrotCoinStruct | undefined;
  coinA: ParrotCoinStruct | undefined;
}
const SwapChart: FC<OwnProps> = ({ coinA, coinB }) => {
  const [time, setTime] = useState('all');
  const { isEmpty, data, poolId } = useParrotPoolPriceOhlc(coinA?.type || '', coinB?.type || '');

  if (isEmpty)
    return (
      <div className={styles.nothing}>
        <Nothing text="Price chart is currently not available for this pair." />
      </div>
    );

  if (!poolId) return <SwapChartLoading />;

  console.log(data);
  return (
    <div className={styles.wrapper}>
      <div className={styles.top}>
        <div className={styles.symbol}>
          <img src={coinA?.iconUrl || ''} /> {coinA?.symbol}
          <span>/</span>
          <img src={coinB?.iconUrl || ''} /> {coinB?.symbol}
        </div>
        <div className={styles.tabs}>
          {tabs.map((tab) => (
            <div
              key={tab.value}
              className={time === tab.value ? styles.active : ''}
              onClick={() => setTime(tab.value)}
            >
              {tab.label}
            </div>
          ))}
        </div>
      </div>
      {data && <div className={styles.bottom}></div>}
    </div>
  );
};

export default SwapChart;
